import React from "react";
import { CircleNotch, WarningCircle, Tray } from "@phosphor-icons/react";

export function LoadingState({ label = "Loading…", testId = "loading-state" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-slate-500" data-testid={testId}>
      <CircleNotch className="w-9 h-9 text-brand animate-spin mb-3" />
      <p className="text-sm font-medium">{label}</p>
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", subtitle = "", testId = "empty-state" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center px-6" data-testid={testId}>
      <div className="w-16 h-16 rounded-2xl bg-brand-light flex items-center justify-center mb-4">
        <Tray className="w-8 h-8 text-brand" weight="duotone" />
      </div>
      <h3 className="font-heading font-bold text-lg text-slate-800">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-sm">{subtitle}</p>}
    </div>
  );
}

export function ErrorState({ onRetry, message = "Unable to load data.", testId = "error-state" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center px-6" data-testid={testId}>
      <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-4">
        <WarningCircle className="w-8 h-8 text-red-500" weight="duotone" />
      </div>
      <h3 className="font-heading font-bold text-lg text-slate-800">Something went wrong</h3>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid="error-retry-button"
          className="mt-4 px-5 h-11 rounded-xl bg-brand text-white font-semibold text-sm hover:bg-brand-hover transition-colors"
        >
          Try again
        </button>
      )}
    </div>
  );
}
